import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

// List CV documents (DocumentGroups) for a consultant.
// GET /documents/cv?consultantId=...
// Returns the raw response.data (callers normalize array/items/data shapes).
export const listCvDocuments = async (consultantId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/documents/cv`, {
    params: { consultantId },
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// Download a single deliverable of a DocumentGroup as a blob.
// GET /documents/group/{reqId}/download?kind=...
// Caller is responsible for reading `.data` (Blob) and `.headers`
// (e.g. content-disposition for the filename).
export const downloadDocumentGroupDeliverable = async (reqId, kind, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(
    `${BASE_URL}/documents/group/${reqId}/download?kind=${encodeURIComponent(kind)}`,
    {
      responseType: "blob",
      ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
    }
  );
  return response;
};

// Submit a CV processing job (multipart). The caller builds the FormData
// (cvFile, jobDescFile, language, jobType, deliverable flags, templateId,
// consultantId). POST /api/cv
export const submitCvProcessing = async (formData) => {
  const response = await axios.post(`${BASE_URL}/api/cv`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return response.data;
};
